import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { ConfirmationModal } from 'vl-common/src/components/Modals';
import AddDependantForm from './AddDependantForm';

const { Paragraph } = Typography;

const AddDependantModal = ({ open, onCancel, user, updateProxyRequestDetails, setUpdateProxyRequestDetails }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [titleOptions, setTitleOptions] = useState<
    {
      title: string;
    }[]
  >([]);
  const [sexOptions, setSexOptions] = useState<
    {
      sex_code: string;
      sex_desc: string;
    }[]
  >([]);

  const closeModal = () => {
    setUpdateProxyRequestDetails(null);
    onCancel();
  };

  useEffect(() => {
    const getMetaDetails = async () => {
      const metaList = await dispatch(actions.usersMeta());
      if (metaList.meta) {
        setTitleOptions(metaList.meta[0].titles);
        setSexOptions(metaList.meta[0].sexes);
      }
    };
    getMetaDetails();
  }, []);

  return (
    <ConfirmationModal
      data-testid="add-dependant-modal"
      closable
      footer={false}
      open={open}
      onCancel={closeModal}
      width={1000}
      destroyOnHidden
      title="Create a dependant"
    >
      <Paragraph style={{ marginBottom: 24 }}>
        {t('Please submit the details of the patient you would like to support')}
      </Paragraph>
      <AddDependantForm
        titleOptions={titleOptions}
        sexOptions={sexOptions}
        onCancel={onCancel}
        user={user}
        updateProxyRequestDetails={updateProxyRequestDetails}
        setUpdateProxyRequestDetails={setUpdateProxyRequestDetails}
      />
    </ConfirmationModal>
  );
};

export default AddDependantModal;
